import { designSystemColors, otherColors } from '@klv/shared/styles/colors';

const searchResultsCard = {
  bannerBackgroundColor: designSystemColors.sand,
  borderColor: otherColors.gray40,
  titleColor: designSystemColors.charcoal,
};

export default searchResultsCard;
